import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';



@Injectable({
    providedIn: 'root'
})
export class EventFilterQuery extends Query<any> {
    document = gql`
        query blockEventCodeFilter($serialNav: Float!, $fromTS: Float!, $toTS: Float!, $code: String) {
            turbines(where: { serialNav: $serialNav }) {
                blockEventCodeFilter(startTS: $fromTS, endTS: $toTS, code: $code) {
                    _id
                }
            }
        }
    `;
}
